// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"1f7fada8","163":"dc940190","419":"1ef4b488","563":"0ff53f3d","787":"788d736c"}[chunkId] + ".chunk.js";
};